'use client';

import { trackingConfig } from '@/lib/tracking/config.tracking';
import {
  declineAllConsent,
  grantConsentForEverything,
} from '@/lib/tracking/utils.tracking';
import { ReactNode } from 'react';
import CookieConsent from 'react-cookie-consent';
import { motion } from 'framer-motion';
import { CookieIcon } from 'lucide-react';

export const RootInnerLayout = ({ children }: { children: ReactNode }) => (
  <>
    <main className="w-full h-full relative">{children}</main>
    <motion.div
      initial={{ y: '100vh', opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: 'easeInOut' }}
      className="fixed inset-x-0 bottom-0 z-50"
    >
      <CookieConsent
        disableStyles={true}
        cookieName={trackingConfig.cookieBannerCookieName}
        buttonText="Accepteren"
        declineButtonText="Afwijzen"
        enableDeclineButton
        onAccept={grantConsentForEverything}
        onDecline={declineAllConsent}
        location="bottom"
        containerClasses="border-2 w-full px-6 py-4 bg-white text-center flex justify-center items-center flex-wrap shadow gap-3 md:gap-8 rounded-t-4xl shadow"
        buttonClasses="px-8 py-1.5 text-lg inline-flex rounded-full text-sm text-white font-semibold transition bg-[var(--secondary)] hover:bg-[var(--secondary)]/50 transition-colors ease-in-out duration-100"
        declineButtonClasses="px-8 py-1.5 text-lg inline-flex rounded-full text-sm font-semibold transition bg-gray-200 text-black hover:bg-gray-100 transition-colors ease-in-out duration-100 mr-4"
      >
        <div className="flex gap-4">
          <CookieIcon />
          <p>
            Wij gebruiken cookies voor een betere ervaring. Door te klikken op
            &apos;Accepteren&apos; ga je akkoord.
          </p>
        </div>
      </CookieConsent>
    </motion.div>
  </>
);
